module.exports = __webpack_public_path__ + "static/media/icon-checkmark-hover.40b668c3.svg";